import React from 'react';
import { PageSection, PageSectionVariants, EmptyState, Title, EmptyStateBody } from '@patternfly/react-core';
import { useSelector } from 'react-redux';

import { StoreState } from '../../store/reducers';

import './../customization/customization-page.css';
import { CustomizationObjectType } from '../../store/model-customization-types';
import CustomizationToolbar from '../customization/CustomizationToolbar';
import GlobalRoiCustomizationCollectionForm from './GlobalRoiCustomizationCollectionForm';
import FullRoiDetailsModal from '../customization/FullRoiDetailsModal';
import { useTranslation } from 'react-i18next';

export const GLOBAL_TAB_ID = 'global';

const CustomizationPage = () => {

    const appClient = useSelector((state: StoreState) => state.currentAppClient);
    const { t } = useTranslation();

    const customizationFetchError = useSelector((state: StoreState) => state.customizationFetchError);
    const appConfig = useSelector((state: StoreState) => state.appConfig);

    return (
        <>

            {appConfig && appConfig.showErrorsInUi && customizationFetchError !== null ? (
                <PageSection variant={PageSectionVariants.light}>
                    <EmptyState>
                        <Title headingLevel="h4" size="lg">An error occurred</Title>
                        <EmptyStateBody>
                            An error occurred when trying to load customization page: {customizationFetchError}
                        </EmptyStateBody>
                    </EmptyState>
                </PageSection>
            ) : (
                <>
                    <PageSection variant={PageSectionVariants.light}>
                        <CustomizationToolbar
                            currentView={CustomizationObjectType.GlobalRoi}
                            customizationOutputId={GLOBAL_TAB_ID}
                        />

                        <FullRoiDetailsModal />

                        <PageSection variant={PageSectionVariants.light}>
                            {appClient === undefined ? (
                                <EmptyState>
                                    <Title headingLevel="h4" size="lg">{t('selectConfigurationTarget.title')}</Title>
                                    <EmptyStateBody>{t('selectConfigurationTarget.message')}</EmptyStateBody>
                                </EmptyState>
                            ) : (
                                <GlobalRoiCustomizationCollectionForm />
                            )}
                        </PageSection>

                    </PageSection>
                </>
            )
            }

        </>
    );
}

export default CustomizationPage;
